import { ElSwitch } from '@pharmsnap/shared/element-ui'
import './GMiniSwitch.scss'
export const GMiniSwitch = (ctx: any) => {
  return <ElSwitch data-testid="g-mini-switch" class={['GMiniSwitch', ctx.props.size === 'large' ? 'LargeGMiniSwitch' : '']} {...ctx.data}></ElSwitch>
}
